const etEE= {
    login: {
      title: 'Sisselogimine',
      sign_in_btn: 'Sisselogimine'
    },
    bar: {
        logout: 'Väljalogimine',
        languages: 'Keeled',
        settings: 'Avage seaded'
    },
    language: {
      name: 'Eesti keel (EE)',
    },
    attributePage: {
        title: 'Atribuutide muudatused',
        viewChanges: 'Vaadake muudatusi',
        dateTime: 'Kuupäev',
        notificationType: 'Märguande tüüp',
        notificationValue: 'Märguande väärtus',
        oldValue: 'Vana väärtus',
        newValue: 'Uus väärtus',
        accept: 'Kinnita',
        reject: 'Lükka tagasi',
    },
    Home: 'Koduleht',
    load: 'Algne laadimine...',
    Requested: "Taotletud",
    Viewed: "Vaadatud",
    Executing: "Täitmine",
    Completed: "Lõpetatud",
    Expired: "Aegunud",
    Cancelled: "Tühistatud",
    Error: "Viga",
    Rejected: "Tagasilükatud",
    error: 'Midagi läks valesti; palun proovige hiljem uuesti.',
    displayname: 'Kuvatav nimi',
    givenname: 'Eesnimi',
    surname: 'Perekonnanimi',
    email: 'E-posti aadress',
    mail: 'E-posti aadress',
    name: 'Eesnimi',
    firstname: 'Eesnimi',
    lastname: 'Perekonnanimi',
    footer_copyright: 'Kõik õigused on kaitstud.'
  };
  
  export default etEE;
  